import { NftDetails } from "./types"

export const sortNftByRank = (nftList: NftDetails[]) => {
  return nftList.sort((a, b) => {
    return a?.rank && b?.rank ? a.rank - b.rank : 0
  })
}

export const sortNftId = (nftIds: string[]) => {
  return [...nftIds].sort((a, b) => {
    return parseInt(a) - parseInt(b)
  })
}

export const checkIdListChanged = (idListA: string[], idListB: string[]) => {
  return sortNftId(idListA).join(",") !== sortNftId(idListB).join(",")
}
